import { router } from "@inertiajs/react";
import { useAtom } from "jotai";

import { canShowExistingUserPageAtom } from "@atoms/checkoutAtom.ts";

import { ExistingUserContainer } from "@containers/Checkout/ExistingUserContainer";

const ExistingUserPage = () => {
    const [canShowExistingUserPage] = useAtom(canShowExistingUserPageAtom);

    const renderPage = () => {
        if (!canShowExistingUserPage) {
            router.get(route("login"));
            return;
        }

        return <ExistingUserContainer />;
    };

    return renderPage();
};

export default ExistingUserPage;
